<div *ngIf="purchaseStateStepDropdown then state"></div>
<div *ngIf="!askAddress && !purchaseStateStepDropdown then zipBlock"></div>
<div *ngIf="askAddress && !purchaseStateStepDropdown then zipAddressBlock"></div>

<ng-template #state>
  <div class="zip">
    <h2 class="step-title">{{stateHeader}}</h2>
    <div class="columns">
      <div class="column is-three-fifths-tablet has-text-right-tablet">
        <app-states-dropdown
        [initialState]="initialState"
        [className]="'purchase-state-select'"
        [showError]="showSelectsError"
        (selected)="selectState($event)"
        ></app-states-dropdown>
      </div>
    
      <div class="column is-two-fifths-tablet has-text-left-tablet">
        <button class="button continue is-large has-shadow-small"  (click)="submit()">
          Continue
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #zipBlock>
  <div class="zip">
    <h2 class="step-title">{{zipCodeHeader}}</h2>
    <div class="columns">
      <div class="column is-three-fifths-tablet has-text-right-tablet">
        <input inputmode="numeric" class="input is-large" type="text" placeholder="Zip Code" maxlength="5"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors && !purchaseStateStepDropdown}"
        formControlName="zipCode" #zipCode (change)="snap()" name="zipCode" digitOnly>
        <p class="help is-danger" *ngIf="controls[0].touched && controls[0].errors && !purchaseStateStepDropdown">Please enter a valid 5 digit US zip code.</p>
        <!-- <p class="help is-danger" *ngIf="controls[0].touched && controls[0].errors ">Please enter a valid 5 digit US zip code.</p> -->
        <br/>
          <p class="step-subtitle" *ngIf="notDebtSettlement">Get rates with no credit check required!</p>
      </div>
    
      <div class="column is-two-fifths-tablet has-text-left-tablet">
        
        <button class="button continue is-large has-shadow-small"  (click)="submit()">
          Continue
          <i class="fas fa-chevron-right"></i>
        </button> 
        
      </div>
    </div>
  </div>
<a class="ng-star-inserted not-sure" (click)="submit()">Don't Know</a>
</ng-template>
    


<ng-template #zipAddressBlock>
  <h2 class="step-title">{{zipCodeHeader}}</h2>
  <p class="step-subtitle">Get rates with no credit check required!</p>
  <div class="field">
    <div class="control">
      <input inputmode="numeric" class="input is-large" type="text" placeholder="Zip Code" maxlength="5"
      [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors && !purchaseStateStepDropdown}"
      formControlName="zipCode" #zipCode (change)="snap()" name="zipCode" digitOnly>
    </div>

    <p class="help is-danger" *ngIf="controls[0].touched && controls[0].errors && ShowErrorMessage && !purchaseStateStepDropdown">Please enter a valid 5 digit US zip code.</p>
  </div>

  <h2 class="step-title">{{streetAddressHeader}}</h2>

  <p class="is-size-7 assurance">{{subtext}}</p>

  <div class="field">
    <div class="control">
      <input class="input is-large" type="text" placeholder="Street Address"
      [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors && !purchaseStateStepDropdown}"
      formControlName="streetAddress" #streetAddress (change)="snap()" name="streetAddress" [readonly]="disableStreetAddress">
    </div>

    <p class="help is-danger" *ngIf="controls[1].touched && controls[1].errors && ShowErrorMessage && !purchaseStateStepDropdown">Please fill out your valid street address.</p>
    
  </div>

  <button  class="button continue is-large has-shadow-small"  (click)="submit()">
    Continue
    <i class="fas fa-chevron-right"></i>
  </button>
<a class="ng-star-inserted not-sure" (click)="submit()">Don't Know</a>
<!-- <a *ngIf="NotSureZipCodeAddress" class="ng-star-inserted not-sure" (click)="reloadComponent()">Not Sure</a> -->
</ng-template>